var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 9.12 15.99",
    style: {
      enableBackground: "new 0 0 9.12 15.99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ffffff;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Arrow",
    className: "st0",
    d: "M8.49,7.37L1.85,0.72C1.5,0.41,0.96,0.43,0.64,0.78c-0.3,0.33-0.3,0.82,0,1.15l6.04,6.05l-6.04,6.04 c-0.34,0.33-0.35,0.87-0.03,1.21s0.87,0.35,1.21,0.03c0.01-0.01,0.02-0.02,0.03-0.03l6.65-6.65C8.82,8.24,8.82,7.7,8.49,7.37z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightWhite);
export default __webpack_public_path__ + "static/media/arrow-right-white.7de5dd71b3bd221434b432c014ba5ebe.svg";
export { ForwardRef as ReactComponent };